import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navi from './pages/Navi';
import About from './pages/About';
import Footer from './pages/Footer';
import Header from './pages/Header';
import Oferta from './pages/Oferta';
import Partners from './pages/Partners';
import Kontakt from './pages/Kontakt';
import Helpdesk from './pages/Helpdesk';
import Remote from './pages/Remote';
import LoginForm from "./pages/LoginForm";
import AdminPanel from "./pages/AdminPanel";
import PrivateRoute from "./pages/PrivateRoute";
import PolitykaPrywatnosci from './pages/PolitykaPrywatnosci';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <BrowserRouter>
      <div className="container__main">
        <div className="header-navi">
          <Header />
          <Navi />
        </div>

        <main>
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/oferta" element={<Oferta />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/helpdesk" element={<Helpdesk />} />
            <Route path="/remote" element={<Remote />} />
            <Route
              path="/login"
              element={<LoginForm onLoginSuccess={() => setIsAuthenticated(true)} />}
            />
            <Route
              path="/admin"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <AdminPanel />
                </PrivateRoute>
              }
            />
            <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
